module.exports = __webpack_public_path__ + "static/media/top_bg.383371e6.png";